import { post } from "../../../services/request";

// UserId is never sent from the client; the API derives it from the auth token.
export const changePassword = (payload) => {
  return post("RadUser/ChangePassword", payload);
};
